import React from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import AppLayout from "layouts/app-layout";
import AuthLayout from "layouts/auth-layout";
import { APP_PREFIX_PATH, AUTH_PREFIX_PATH } from "configs/AppConfig";
import { useAuth } from "../data/hooks/firebase/useAuth";
import Loading from "../components/shared-components/Loading";
import MfaRequirementGuard from "./auth-views/components/MfaRequirementGuard";
import TotpSetupWrapper from "../components/layout-components/TotpSetupWrapper";

// A wrapper that routes user to the dashboard when he/she lands on
// the login page while already authenticated
const CheckAlreadyAuthenticated = ({ children, auth, loading }) => {
  // Don't redirect during loading to prevent unwanted redirects on page reload
  if (loading) {
    return <Loading cover="page" />;
  }
  return !auth.isAuthenticated || !auth.user?.emailVerified ? children : <Navigate to={APP_PREFIX_PATH} replace />;
};

// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated or if auth is not
// yet loaded
const PrivateRoute = ({ children, auth, loading }) => {
  // Don't redirect during loading to prevent unwanted redirects on page reload
  if (loading) {
    return <Loading cover="page" />;
  }
  return auth.isAuthenticated && auth.user ? children : <Navigate to={AUTH_PREFIX_PATH} replace />;
};

export const Views = () => {
  const location = useLocation();
  const { user, isAuthenticated, loading } = useAuth();

  return (
    <Routes>
      <Route
        path="/"
        element={
          <>
            <Navigate to={APP_PREFIX_PATH} replace />
          </>
        }
      />
      <Route
        path={AUTH_PREFIX_PATH + "/*"}
        element={
          <>
            <CheckAlreadyAuthenticated auth={{ user, isAuthenticated }} loading={loading}>
              <AuthLayout />
            </CheckAlreadyAuthenticated>
          </>
        }
      />
      <Route path="/auth/mfa-setup" element={<TotpSetupWrapper />} />
      <Route
        path={APP_PREFIX_PATH + "/*"}
        element={
          <>
            <PrivateRoute auth={{ user, isAuthenticated }} loading={loading}>
              <MfaRequirementGuard>
                <AppLayout location={location} />
              </MfaRequirementGuard>
            </PrivateRoute>
          </>
        }
      />
    </Routes>
  );
};

export default Views;
